export const EVENTS = {
  SIGNUP_FORM_SUBMISSION: 'sign_up',
}
